
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftLeft25 as ObiThreewayStackedInleftLeft25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-left-25.js';
 
 
 

 
 export const ObiThreewayStackedInleftLeft25 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-left-25',
   elementClass: ObiThreewayStackedInleftLeft25Element,
   events: {
     
   }
  });
 
 